module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-20"
  }, [(_vm.display.direction == 10) ? _c('table', {
    staticClass: "cross-table",
    attrs: {
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.table), function(item) {
    return _c('th', [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.table), function(item) {
    return _c('td', [_vm._v(_vm._s(item.value))])
  }))])]) : _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "数值"
    }
  })]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44b3f4bf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/chart/dimensionalTable.vue
// module id = 1842
// module chunks = 2